var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1D1D1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85714 18.3C9.85714 18.685 10.1786 19 10.5714 19H13.4286C13.8214 19 14.1429 18.685 14.1429 18.3V17.6H9.85714V18.3ZM12 5C9.24286 5 7 7.198 7 9.9C7 11.566 7.85 13.029 9.14286 13.918V15.5C9.14286 15.885 9.46429 16.2 9.85714 16.2H14.1429C14.5357 16.2 14.8571 15.885 14.8571 15.5V13.918C16.15 13.029 17 11.566 17 9.9C17 7.198 14.7571 5 12 5ZM14.0357 12.77L13.4286 13.19V14.8H10.5714V13.19L9.96429 12.77C9 12.112 8.42857 11.041 8.42857 9.9C8.42857 7.968 10.0286 6.4 12 6.4C13.9714 6.4 15.5714 7.968 15.5714 9.9C15.5714 11.041 15 12.112 14.0357 12.77Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightbulb);
export default __webpack_public_path__ + "static/media/icon-lightbulb.f0dad7994dc269b71070a886cc4ccff0.svg";
export { ForwardRef as ReactComponent };